module.exports = "<div class=\"center-wrap\">\n  <div class=\"center empty-state\">\n    The contact page will go here.\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /Users/nicholasgerard/Documents/Quibbl/quibbl/src/app/contact/contact.component.html
// module id = ../../../../../src/app/contact/contact.component.html
// module chunks = main